export default __webpack_public_path__ + "static/media/HelveticaNeueCyr-UltraLight.7a9ed954.woff";